module.exports = __webpack_public_path__ + "img/pickup_parked.22844666.svg";